import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, query, orderByChild } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJBNo3wLiaIDe-oVXKIl5HqqyVo0bTkok",
  authDomain: "frenkel-db.firebaseapp.com",
  databaseURL: "https://frenkel-db-default-rtdb.firebaseio.com",
  projectId: "frenkel-db",
  storageBucket: "frenkel-db.firebasestorage.app",
  messagingSenderId: "59817429070",
  appId: "1:59817429070:web:ec471fd9cf9c51614b9b1f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app); // Realtime Database
const storage = getStorage(app);


export {
  database,
  storage,
  ref,
  get,
  query,
  orderByChild,
  storageRef,
  uploadBytes,
  getDownloadURL
}